import { type IdTyping, type IriTyping, type NoteTyping } from '@shared/typings';

export const combineDescriptions = (notes: NoteTyping[]): string => notes.map(note => note.description)
    .join('\n\n');

export const filterNotes = (notes: NoteTyping[], id: IdTyping): NoteTyping[] => notes.filter(note => note.teams
    ?.map(team => team?.globalId)
    ?.filter(teamId => Boolean(teamId))
    ?.includes(id));

export const buildNewNotes = (notes: NoteTyping[] = []): (Omit<NoteTyping, 'id' | 'iri' | 'teams'> & { teams: IdTyping[] })[] =>
    notes.map(({ id: _id, iri: _iri, teams, ...note }) => ({
        ...note,
        teams: teams.map(team => team.id),
    }));

/**
 * Strips the `id`/`iri` from notes copied from a source product/space before they are
 * attached to a timeslot product/space in the quote form. Those ids reference the note's
 * original `product`/`space` relation, so keeping them makes the backend see two relations
 * (e.g. `product` and `timeslotProduct`) and reject the mutation with
 * "Only one relation can be set, but 2 given".
 *
 * Unlike `buildNewNotes`, teams are kept as objects so the form/cards can still render them;
 * team flattening to ids happens later in the save payload via `mapNotes`.
 */
export const stripNoteRelations = <T extends { id?: IdTyping, iri?: IriTyping }>(
    notes: (T | null | undefined)[] = [],
): Omit<T, 'id' | 'iri'>[] =>
        notes
            .filter((note): note is T => Boolean(note))
            .map(({ id: _id, iri: _iri, ...note }) => note);
